/* ─────────────────────────────────────────────────────────────
   sidebar-shell.js
   Upload to: Shopify Admin → Online Store → Themes → Edit Code → Assets
   ───────────────────────────────────────────────────────────── */

(function () {

  /* ── Sidebar collapse / expand ─────────────────────────────── */
  function toggleSidebar() {
    const sidebar = document.getElementById('sidebar');
    const isCollapsed = sidebar.classList.toggle('collapsed');
    document.body.classList.toggle('sidebar-collapsed', isCollapsed);
    localStorage.setItem('sidebarCollapsed', isCollapsed);
  }

  /* ── Sub-nav accordion ─────────────────────────────────────── */
  function toggleSubNav(itemId, event) {
    event.preventDefault();
    const sidebar = document.getElementById('sidebar');
    const item = document.getElementById(itemId);
    const isCollapsed = sidebar.classList.contains('collapsed');
    const isOpen = item.classList.contains('is-open');

    // If sidebar is collapsed, expand it and open this item
    if (isCollapsed) {
      sidebar.classList.remove('collapsed');
      document.body.classList.remove('sidebar-collapsed');
      localStorage.setItem('sidebarCollapsed', false);
      item.classList.add('is-open');
      return;
    }

    // Close ALL open items unconditionally
    document.querySelectorAll('.sidebar-nav-item.is-open').forEach(function (el) {
      el.classList.remove('is-open', 'has-active-child');
    });

    // Open the clicked item (unless it was already open, in which case leave it closed)
    if (!isOpen) {
      item.classList.add('is-open');
    }
  }

  /* ── Sub-link active state ─────────────────────────────────── */
  function initSubLinks() {
    document.querySelectorAll('.sidebar-sub-nav-link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.stopPropagation();
        document.querySelectorAll('.sidebar-sub-nav-link.active').forEach(function (el) {
          el.classList.remove('active');
        });
        document.querySelectorAll('.sidebar-nav-item.has-active-child').forEach(function (el) {
          el.classList.remove('has-active-child');
        });
        this.classList.add('active');
        var parentItem = this.closest('.sidebar-nav-item');
        if (parentItem) parentItem.classList.add('has-active-child');
      });
    });
  }

  /* ── Restore collapsed state from localStorage ─────────────── */
  function restoreState() {
    if (localStorage.getItem('sidebarCollapsed') === 'true') {
      document.getElementById('sidebar').classList.add('collapsed');
      document.body.classList.add('sidebar-collapsed');
    }
  }

  /* ── Expose functions globally for onclick attributes ──────── */
  window.toggleSidebar = toggleSidebar;
  window.toggleSubNav  = toggleSubNav;

  /* ── Init on DOM ready ─────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    restoreState();
    initSubLinks();
  });

})();